import React from 'react';

export const Active = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="64"
      viewBox="0 0 64 68"
    >
      <g
        id="Group_1081"
        data-name="Group 1081"
        transform="translate(-989.001 -231)"
      >
        <g id="man" transform="translate(989.001 231)">
          <path
            id="Path_331"
            data-name="Path 331"
            d="M71.969,74.708,69.549,61.426l-.008-.03a11.351,11.351,0,0,0-8.578-8.024l-12.7-2.684v-2.8A14.535,14.535,0,0,0,54.3,38.056h.665a3.624,3.624,0,0,0,3.613-3.627V31.319a3.624,3.624,0,0,0-3.613-3.627h-.516V25.246a9.194,9.194,0,0,0,5.275-6.831,10.951,10.951,0,0,0-.154-4.481,1.031,1.031,0,0,0-1.852-.29c-.907,1.367-5.454-1.15-7.165-2.1-.252-.14-.485-.269-.7-.385A17.073,17.073,0,0,0,40,8,14.5,14.5,0,0,0,25.549,22.51v5.182h-.516a3.624,3.624,0,0,0-3.613,3.627v3.109a3.624,3.624,0,0,0,3.613,3.627H25.7a14.535,14.535,0,0,0,6.045,9.828v2.8l-12.7,2.684A11.351,11.351,0,0,0,10.46,61.4l-.008.03L8.033,74.708a1.034,1.034,0,0,0,1,1.292H70.969a1.034,1.034,0,0,0,1-1.292ZM25.549,35.983h-.516a1.553,1.553,0,0,1-1.548-1.555V31.319a1.553,1.553,0,0,1,1.548-1.555h.516Zm29.419-6.218a1.553,1.553,0,0,1,1.548,1.555v3.109a1.553,1.553,0,0,1-1.548,1.555h-.516V29.764ZM27.614,22.51A12.427,12.427,0,0,1,40,10.073a15.262,15.262,0,0,1,8.788,2.862l.061.036c.215.115.453.247.71.39,2.326,1.288,5.884,3.257,8.253,2.613a7.4,7.4,0,0,1-4.8,7.656,1.037,1.037,0,0,0-.626.952v1.6a10.409,10.409,0,0,1-5.458-4.087,1.03,1.03,0,0,0-1.577-.161,16.5,16.5,0,0,1-17.739,3.52Zm0,13.473V27.667a18.558,18.558,0,0,0,18.32-3.458,12.475,12.475,0,0,0,6.454,4.124v7.65a12.387,12.387,0,1,1-24.774,0ZM46.194,49.091v2.438a4.618,4.618,0,0,1-2.026,4.025A7.489,7.489,0,0,1,40,56.711c-4.572,0-6.194-2.792-6.194-5.182V49.091A14.384,14.384,0,0,0,46.194,49.091ZM60.646,73.927V66.038a1.032,1.032,0,1,0-2.065,0v7.889H21.42V66.038a1.032,1.032,0,1,0-2.065,0v7.889H10.361l2.088-11.975A9.288,9.288,0,0,1,19.464,55.4l12.377-2.616a6.561,6.561,0,0,0,2.4,4.164A9.166,9.166,0,0,0,40,58.784a9.166,9.166,0,0,0,5.756-1.834,6.561,6.561,0,0,0,2.4-4.164L60.538,55.4a9.288,9.288,0,0,1,7.016,6.551l2.088,11.975Z"
            transform="translate(-8.001 -8)"
            fill="#329926"
          />
          <path
            id="Path_332"
            data-name="Path 332"
            d="M238.2,265.033A1.033,1.033,0,0,0,237.164,264h-4.131a1.033,1.033,0,1,0,0,2.066h4.131A1.033,1.033,0,0,0,238.2,265.033Z"
            transform="translate(-203.099 -230.832)"
            fill="#329926"
          />
          <circle
            id="Ellipse_31"
            data-name="Ellipse 31"
            cx="2"
            cy="2"
            r="2"
            transform="translate(23.985 22.08)"
            fill="#329926"
          />
          <circle
            id="Ellipse_32"
            data-name="Ellipse 32"
            cx="2"
            cy="2"
            r="2"
            transform="translate(35.978 22.08)"
            fill="#329926"
          />
        </g>
        <path
          id="Path_333"
          data-name="Path 333"
          d="M-18548.92,821.694l2.777,2.952,4.684-4.974"
          transform="translate(19575.82 -533.107)"
          fill="none"
          stroke="#329926"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
        />
      </g>
    </svg>
  );
};
export const Inactive = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="64"
      viewBox="0 0 64 68"
    >
      <g
        id="Group_1082"
        data-name="Group 1082"
        transform="translate(-1122.001 -231)"
      >
        <g id="man" transform="translate(1122.001 231)">
          <path
            id="Path_331"
            data-name="Path 331"
            d="M71.969,74.708,69.549,61.426l-.008-.03a11.351,11.351,0,0,0-8.578-8.024l-12.7-2.684v-2.8A14.535,14.535,0,0,0,54.3,38.056h.665a3.624,3.624,0,0,0,3.613-3.627V31.319a3.624,3.624,0,0,0-3.613-3.627h-.516V25.246a9.194,9.194,0,0,0,5.275-6.831,10.951,10.951,0,0,0-.154-4.481,1.031,1.031,0,0,0-1.852-.29c-.907,1.367-5.454-1.15-7.165-2.1-.252-.14-.485-.269-.7-.385A17.073,17.073,0,0,0,40,8,14.5,14.5,0,0,0,25.549,22.51v5.182h-.516a3.624,3.624,0,0,0-3.613,3.627v3.109a3.624,3.624,0,0,0,3.613,3.627H25.7a14.535,14.535,0,0,0,6.045,9.828v2.8l-12.7,2.684A11.351,11.351,0,0,0,10.46,61.4l-.008.03L8.033,74.708a1.034,1.034,0,0,0,1,1.292H70.969a1.034,1.034,0,0,0,1-1.292ZM25.549,35.983h-.516a1.553,1.553,0,0,1-1.548-1.555V31.319a1.553,1.553,0,0,1,1.548-1.555h.516Zm29.419-6.218a1.553,1.553,0,0,1,1.548,1.555v3.109a1.553,1.553,0,0,1-1.548,1.555h-.516V29.764ZM27.614,22.51A12.427,12.427,0,0,1,40,10.073a15.262,15.262,0,0,1,8.788,2.862l.061.036c.215.115.453.247.71.39,2.326,1.288,5.884,3.257,8.253,2.613a7.4,7.4,0,0,1-4.8,7.656,1.037,1.037,0,0,0-.626.952v1.6a10.409,10.409,0,0,1-5.458-4.087,1.03,1.03,0,0,0-1.577-.161,16.5,16.5,0,0,1-17.739,3.52Zm0,13.473V27.667a18.558,18.558,0,0,0,18.32-3.458,12.475,12.475,0,0,0,6.454,4.124v7.65a12.387,12.387,0,1,1-24.774,0ZM46.194,49.091v2.438a4.618,4.618,0,0,1-2.026,4.025A7.489,7.489,0,0,1,40,56.711c-4.572,0-6.194-2.792-6.194-5.182V49.091A14.384,14.384,0,0,0,46.194,49.091ZM60.646,73.927V66.038a1.032,1.032,0,1,0-2.065,0v7.889H21.42V66.038a1.032,1.032,0,1,0-2.065,0v7.889H10.361l2.088-11.975A9.288,9.288,0,0,1,19.464,55.4l12.377-2.616a6.561,6.561,0,0,0,2.4,4.164A9.166,9.166,0,0,0,40,58.784a9.166,9.166,0,0,0,5.756-1.834,6.561,6.561,0,0,0,2.4-4.164L60.538,55.4a9.288,9.288,0,0,1,7.016,6.551l2.088,11.975Z"
            transform="translate(-8.001 -8)"
            fill="#ee2b48"
          />
        </g>
        <g
          id="Group_1080"
          data-name="Group 1080"
          transform="translate(1162.375 286.523)"
        >
          <path
            id="Path_334"
            data-name="Path 334"
            d="M-18514.107,809.97l4.99,4.991"
            transform="translate(18514.107 -809.97)"
            fill="none"
            stroke="#ee2b48"
            stroke-linecap="round"
            stroke-width="2"
          />
          <path
            id="Path_335"
            data-name="Path 335"
            d="M-18509.117,809.97l-4.99,4.991"
            transform="translate(18514.107 -809.97)"
            fill="none"
            stroke="#ee2b48"
            stroke-linecap="round"
            stroke-width="2"
          />
        </g>
      </g>
    </svg>
  );
};
